/**
 * Cart drawer "change style" sheet (snippets/cart-line-item.liquid, compact rows).
 * Tapping a style in the sheet swaps the cart line to that variant with the same quantity:
 * the new variant is added first, then the old line is removed, both through Standard Actions
 * (window.Shopify.actions.updateCart), whose override refreshes the drawer partials.
 * Buttons: [data-cart-swap][data-line-key][data-variant-id][data-quantity]; the current style carries aria-current.
 */
let busy = false;

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-cart-swap]') : null;
  if (!button || busy) return;
  const dialog = button.closest('dialog');
  if (button.getAttribute('aria-current') === 'true' || button.disabled) {
    dialog?.close();
    return;
  }
  const { lineKey, variantId } = button.dataset;
  const quantity = Number(button.dataset.quantity) || 1;
  const updateCart = window.Shopify?.actions?.updateCart;
  if (!lineKey || !variantId || !updateCart) return;

  busy = true;
  const list = button.closest('ul');
  list?.setAttribute('aria-busy', 'true');
  if (list) list.style.opacity = '0.5';
  try {
    const added = await updateCart({ lines: [{ merchandiseId: String(variantId), quantity }] }, { event: { context: 'cart' } });
    if (added?.userErrors?.length) throw new Error(added.userErrors[0].message);
    await updateCart({ lines: [{ id: lineKey, quantity: 0 }] }, { event: { context: 'cart' } });
    dialog?.close();
  } catch (error) {
    console.error(error);
    if (list) list.style.opacity = '';
  } finally {
    list?.removeAttribute('aria-busy');
    busy = false;
  }
});
